import React from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ImgToolTip = ({intl, placement, tooltiptext, id, img, 
  className
}) => (
  <OverlayTrigger
    placement={placement}
    overlay={
      <Tooltip id={id}>
        {intl.formatMessage({id: tooltiptext})}
      </Tooltip>
    }
  >
    <img draggable={false} className={className ? className  : "download_icon"} src={img} alt={tooltiptext} />
  </OverlayTrigger>
)

export default ImgToolTip;